import apiFetch from '../apiFetch';
import generateHeaders from '../myHeaders';

const setupSurveyContentSqlServer = (
    surveyId: number,
    hasHotAlert: boolean,
    hasOnlyCompleted: boolean,
    selectedSchema: string,
): Promise<unknown> => {
    const payload = { hasHotAlert, hasOnlyCompleted };

    return apiFetch(
        `${process.env.REACT_APP_API_URL}/configuration/surveys/${surveyId}/sqlserver`,
        { method: 'POST', headers: generateHeaders(selectedSchema), body: JSON.stringify(payload) },
    );
};

export default setupSurveyContentSqlServer;
